import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useMutation } from '@tanstack/react-query';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Stack from '@mui/material/Stack';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Alert from '@mui/material/Alert';
import Divider from '@mui/material/Divider';

import { loginRequest } from '../../services/authService';
import { useAuth } from '../../hooks/useAuth';

function LoginPage() {
  const navigate = useNavigate();
  const location = useLocation();
  const { saveSession } = useAuth();
  const from = location.state?.from?.pathname || '/dashboard';
  const [formValues, setFormValues] = React.useState({
    username: '',
    password: '',
  });

  const mutation = useMutation({
    mutationFn: loginRequest,
    onSuccess: (data) => {
      saveSession({ token: data.token, userInfo: data.userInfo });
      navigate(from, { replace: true });
    },
  });

  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormValues((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (event) => {
    event.preventDefault();
    mutation.mutate(formValues);
  };

  return (
    <Paper
      component="form"
      onSubmit={handleSubmit}
      elevation={0}
      sx={{
        width: '100%',
        maxWidth: 420,
        p: { xs: 3, sm: 4 },
        borderRadius: 3,
        border: '1px solid rgba(15, 23, 42, 0.08)',
        backdropFilter: 'blur(10px)',
      }}
    >
      <Stack spacing={2.5}>
        <Stack spacing={0.5}>
          <Typography variant="h4" sx={{ fontWeight: 700 }}>
            Welcome back
          </Typography>
          <Typography variant="body1" color="text.secondary">
            Access the Malbon staff toolkit and close your shift effortlessly.
          </Typography>
        </Stack>

        {mutation.isError && <Alert severity="error">{mutation.error.message}</Alert>}

        <Stack spacing={2}>
          <TextField
            label="Username"
            name="username"
            type="text"
            placeholder="Enter your phone number"
            value={formValues.username}
            onChange={handleChange}
            fullWidth
            required
          />
          <TextField
            label="Password"
            name="password"
            type="password"
            placeholder="Enter your password"
            value={formValues.password}
            onChange={handleChange}
            fullWidth
            required
          />
        </Stack>

        <Button type="submit" variant="contained" size="large" fullWidth disabled={mutation.isPending}>
          {mutation.isPending ? 'Signing in…' : 'Sign in'}
        </Button>

        <Divider>Need help?</Divider>
        <Typography variant="body2" color="text.secondary">
          Contact your Malbon supervisor if you cannot access your account.
        </Typography>
      </Stack>
    </Paper>
  );
}

export default LoginPage;


